import { render, staticRenderFns } from "./text-node.vue?vue&type=template&id=656e8ec6"
import script from "./text-node.vue?vue&type=script&lang=js"
export * from "./text-node.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports